module.exports = __webpack_public_path__ + "img/marker-w.2fc25815.svg";